import React from "react"
import Staffing1 from "../../img/Staffing1.jpg"
import Staffing2 from "../../img/Staffing2.jpg"
import "../../styles/modal.css"

function Modal({ modalVisible, setModalVisible }) {
  // const modalVisible = props.modalVisible

  function handleClick() {
    setModalVisible(false)
  }

  return modalVisible ? (
    // <div className="modal-wrap">
    //   <div className="modal-panel" style={{ flexDirection: "column", width: "30vw", margin: "44px 15px 0"}}>
    //     <div className="modal-header">
    //       주주 및 투자자 여러분께 안내드립니다.
    //     </div>
    //     <div
    //       className="modal-body"
    //       style={{
    //         height: "calc(100vh - 525px)",
    //         overflowY: "auto",
    //         marginTop: 20
    //       }}
    //     >
    //       <div style={{ paddingTop: 20, textAlign: "center" }}>
    //         주주 및 투자자 여러분께 안내드립니다.
    //         <br />
    //         안녕하십니까. 엠투엠테크는 항상 주주 분들과 잠재적 투자자 분들과의 신뢰를 최우선으로 생각합니다.
    //         <br /><br />
    //         최근 일부 인터넷 주식 동호회 사이트에서 당사와 관련한 기업공개(IPO) 계획 및 그 시점 등에 대한 허위 정보가 유포되고 있는 상황이 확인되었습니다.
    //         <br />
    //         이로 인해 투자 판단에 혼선을 드릴 우려가 있어 안내드리는 바입니다.
    //         <br /><br />
    //         해당 내용은 당사의 공식 발표가 아니며, 당사는 이와 같은 커뮤니티 또는 비공식적인 온라인 채널과는 일절 관련이 없습니다.
    //         <br /><br />
    //         당사는 공식 홈페이지를 통해 사업 내용, 기술력, 특허 현황, 언론보도 등을 포함한 공식적이고 신뢰할 수 있는 기업 정보를 투명하게 공개하고 있습니다.
    //         <br />
    //         따라서 확인되지 않은 비공식 정보에 기반한 투자는 예상치 못한 피해로 이어질 수 있으므로 각별한 주의를 부탁드립니다.
    //         <br /><br />
    //         또한, 사실과 다른 내용을 유포하여 회사의 신뢰를 훼손하거나 주주의 판단을 왜곡시키는 행위에 대해서는 당사는 그 심각성을 엄중히 인식하고 있으며,
    //         <br />
    //         필요시 민·형사상 법적 조치를 포함한 강력한 대응을 검토하고 있음을 알려드립니다.
    //         <br /><br />
    //         당사의 기업 관련 공식 정보는 엠투엠테크 공식 홈페이지를 통해서만 제공됩니다.
    //         <br />
    //         앞으로도 주주 여러분의 소중한 권익 보호와 회사의 신뢰 제고를 위해 책임감 있게 소통하겠습니다.
    //         <br />
    //         <br />
    //         감사합니다.
    //         <br />
    //         주식회사 엠투엠테크 드림

    //       </div>
    //       {/* <div
    //         style={{
    //           position: "relative",
    //           paddingTop: 20,
    //           textAlign: "center",
    //         }}
    //       >
    //         2025년 7월 01일
    //         <br />
    //         주식회사 엠투엠테크
    //         <br />
    //         경기도 성남시 수정구 청계산로 686, 533호, 534호 (고등동, 반도 아이비밸리)
    //         <br />
    //         대표이사 김진기
    //       </div> */}
    //     </div>

    //     <div className="modal-footer">
    //       <div className="button-item">
    //         <button onClick={handleClick}>확인 (닫기)</button>
    //       </div>
    //     </div>
    //   </div>
     <div className="modal-wrap">
      <div className="modal-panel" style={{ flexDirection: "column", width: "30vw", margin: "44px 15px 0" }}>
        <div className="modal-header">
          제12기 정기주주총회소집을 위한 기준일 및 주주명부 폐쇄기간 설정공고
        </div>
        <div
          className="modal-body"
          style={{
            height: "calc(100vh - 600px)",
            overflowY: "auto",
            marginTop: 20
          }}
        >
          상법 제354조 및 본 회사 정관 제15조에 의거하여, <b>2026년 03월 31일</b>{" "}
          개최되는 임시주주총회에서 <b>2025년 12월 31일</b> 현재 주주명부에
          기재되어 있는 주주에게 의결권을 부여하며, 권리주주의 확정을 위해{" "}
          <b>2026년 1월 1일부터 2026년 1월 7일까지</b> 주식의 명의개서, 질권의
          등록 및 그 변경과 말소, 신탁재산의 표시 및 말소 등 주주명부의 기재사항
          변경을 정지함을 공고합니다.
          <br />
          <div
            style={{
              position: "relative",
              paddingTop: 20,
              textAlign: "center",
            }}
          >
            <p style={{ paddingTop: 20, textAlign: "center" }}>
              <p>2026년 2월 23일</p>
              <b>주식회사 엠투엠테크</b>
              <p>경기도 성남시 수정구 청계산로 686,533호,534호 (고등동, 반도 아이비밸리)</p>
              <b>대표이사 김진기</b>
            </p>

          </div>
                  <div className="modal-footer">
          <div className="button-item">
            <button onClick={handleClick}>확인 (닫기)</button>
          </div>
        </div>
        </div>


      </div>
     </div>
  ) : (
    ""
  )
}

export default Modal
